import classNames from "classnames"

export class Focus<T extends string | number = any> {
  protected selector: string
  map: Partial<Record<T, () => true>> = {}
  protected debounceTimeMs: number = 100
  protected removeAnimationTimes: number = 3
  constructor(selector: string) {
    this.selector = selector
  }

  clear() {
    this.map = {}
  }

  remove(key: T, delay: number = 0) {
    setTimeout(() => {
      delete this.map[key]
    }, delay * 1000)
  }

  add(key: T, options?: ScrollIntoViewOptions) {
    let timer: any = null
    this.map[key] = () => {
      timer && clearTimeout(timer)
      timer = setTimeout(() => {
        const dom = document.querySelector(this.selector)
        if (dom) {
          dom.scrollIntoView({
            ...options,
            block: options?.block ?? "nearest",
          })
        }
        this.remove(key, this.removeAnimationTimes)
      }, this.debounceTimeMs)
      return true
    }
  }
}

let timer: any = null
export function addFocusToDom(options: {
  selector?: string
  element?: HTMLElement | HTMLDivElement
  delay?: number
  block?: ScrollLogicalPosition
  style?: string
  scroll?: boolean
}) {
  const { selector, element, delay = 0, style, block, scroll = true } = options
  setTimeout(() => {
    const childDom = element || (selector && document.querySelector(selector))
    if (!childDom) return
    // 检查childDom是否在视口中
    // const rect = childDom.getBoundingClientRect()
    // const inViewport =
    //   rect.top >= 0 &&
    //   rect.left >= 0 &&
    //   rect.bottom <=
    //     (window.innerHeight || document.documentElement.clientHeight) &&
    //   rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    // if (inViewport) return
    // document.querySelectorAll(".p-focus-box").forEach((item) => {
    //   item.classList.remove("p-focus-box")
    // })
    if (style) {
      childDom.setAttribute("style", style)
    }
    if (scroll) {
      childDom.scrollIntoView({
        block: block ?? "center",
        behavior: "smooth",
      })
    }

    childDom.classList.add("p-focus-box")
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      childDom.classList.remove("p-focus-box")
    }, 2000)
  }, delay)
}

export function scrollToNode(params: {
  selector: string
  delay?: number
  options?: ScrollIntoViewOptions
}) {
  const { selector, delay = 50, options } = params
  setTimeout(() => {
    const dom = document.querySelector(selector)
    if (dom) {
      dom.scrollIntoView({
        ...options,
        block: options?.block ?? "nearest",
        behavior: options?.behavior ?? "smooth",
      })
    }
  }, delay)
}

export const focusInstance = new Focus(".p-focus-box")

export const getFocusClassName = (id: string | number) => {
  return classNames({
    "p-focus-box": focusInstance.map[id]?.(),
  })
}
